import type { ApprovalGatedResult } from '@risksmart-app/trpc/src/helpers/with-approval-workflow';

/**
 * Unwrap an approval-gated mutation result for the `useUpdate*TRPC` /
 * `useDelete*TRPC` wrappers: return the applied entity when the change was
 * applied directly, or the caller's `fallback` echo when a change-request was
 * raised/amended (the entity is unchanged on that branch, so callers echo the
 * input Id).
 *
 * Centralises the branch every governed-mutation wrapper repeated inline.
 * Deliberately does NOT throw on the change-request branch — the previous
 * `expectApplied` helper did, which surfaced a false "Failed to save changes"
 * toast for a perfectly-valid CR submission. (#6898)
 */
export const unwrapApprovalGated = <TApplied, TFallback>(
  result: ApprovalGatedResult<TApplied>,
  fallback: TFallback
): TApplied | TFallback =>
  result.status === 'applied' ? result.applied : fallback;
